import { ReactElement } from 'react';
import { useOutletContext } from 'react-router-dom';
import { ArticleOutletContext } from '../MyContent/ArticlesTab/ArticlesTabContainer/ArticlesTabContainer';
import Article from './Article';

const ArticleOutletWrapper = (): ReactElement => {
  const { isLoading } = useOutletContext<ArticleOutletContext>();

  return <Article isCompact isArticleListLoading={isLoading} />;
};

export default ArticleOutletWrapper;
